import { trackEvent } from '@finn-no/pulse-sdk';
import dom from '../lib/dom.js';

const offerIdFromPath = (path) =>
    // path is something like /reise/restplasser/ut?offerId=3c7c4e24&searchclickthrough=true"
    new URL(`http://dummy${path}`).searchParams.get('offerId') ?? 'missing';

const toNumberOrUndefined = (numAsString) => {
    const num = Number.parseInt(numAsString);

    if (Number.isNaN(num)) {
        return undefined;
    }
    return num;
};

//Need to handle norwegian month names they provide invalid date when creating new Date()
//ex: "Ma 4. des." -> "Ma 4. Dec."
const parseDepartureDate = (dateString) => {
    const monthMap = {
        jan: 'Jan',
        feb: 'Feb',
        mar: 'Mar',
        apr: 'Apr',
        mai: 'May',
        jun: 'Jun',
        jul: 'Jul',
        aug: 'Aug',
        sep: 'Sep',
        okt: 'Oct',
        nov: 'Nov',
        des: 'Dec',
    };

    const translated = dateString.replace(
        /\b(jan|feb|mar|apr|mai|jun|jul|aug|sep|okt|nov|des)\b/gi,
        (match) => monthMap[match.toLowerCase()],
    );

    return new Date(translated + ' ' + new Date().getFullYear());
};

export default function setupTrackDropIn({ root }) {
    const track = function (event) {
        const element = dom.closestWithTagName('a', event.target);
        const href = element.getAttribute('href');
        const departureCity = element.getAttribute('data-origin-city');
        const departureAirport = element.getAttribute('data-origin-airport');
        const departureDate = parseDepartureDate(element.getAttribute('data-departure-date'));
        const duration = toNumberOrUndefined(element.getAttribute('data-duration'));
        const arrivalCountry = element.getAttribute('data-country');
        // TODO what to do with region? Should the tracking schema be extended with non-flight support too
        // const arrivalRegion = element.getAttribute('data-region');
        const arrivalCity = element.getAttribute('data-destination');
        const price = element.getAttribute('data-price');
        const provider = element.getAttribute('data-brand');

        // Must work on a copy of departureDate as .setDate changes the original in addition to returning the new timestamp
        const returnDate = new Date(new Date(departureDate).setDate(departureDate.getDate() + duration - 1)); // duration is 1 day "extra"

        // Pulse tracker id: TRL_ev01 (see tracking section in README.md)
        trackEvent({
            type: 'Click',
            intent: 'Purchase',
            name: 'Purchase last minute',
            object: {
                id: offerIdFromPath(href),
                type: 'UIElement',
                elementType: 'Button',
                items: [
                    {
                        id: 'finntravel',
                        type: 'Travel',
                        travelType: 'last_minute',
                        departureCountry: 'Norge',
                        departureCity,
                        departureAirport,
                        destination: arrivalCountry,
                        arrivalCity,
                        // TODO arrivalAirport: 'TODO',
                        departureDate: departureDate.toISOString(),
                        returnDate: returnDate.toISOString(),
                        duration: toNumberOrUndefined(duration),
                        totalPrice: toNumberOrUndefined(price),
                        // TODO carrier: the tracking schema should really support provider vs brand, maybe carrier as a third for flight
                        provider,
                    },
                ],
            },
            target: {
                id: href,
                type: 'ExternalContent',
                name: 'Go to webpage',
                referralCommission: true,
                provider,
            },
            vertical: {
                name: 'travel',
                subVertical: 'last_minute',
            },
        });
    };
    dom.on(root, 'click', '[data-drop-in]', track);
}
